import type {
  Control,
  UseFormGetValues,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form';
import type { RestaurantEvent } from '@shared/types/restaurants';
import { EVENT_STEPS, type EventFormData } from './RestaurantEventForm';
import { AddOnsStep } from './addOns/AddOnsStep';
import { DisclaimersStep } from './disclaimers/DisclaimersStep';
import { EventConfirmationStep } from './eventConfirmation/EventConfirmationStep';
import { EventInformationStep } from './eventInformation/EventInformationStep';
import { GuestCapacityStep } from './guestCapacity/GuestCapacityStep';
import { PhotosStep } from './eventPhotos/PhotosStep';

export type EventFormStepContentProps = {
  stepId: (typeof EVENT_STEPS)[number]['id'];
  control: Control<EventFormData>;
  restaurantEvent?: RestaurantEvent | null;
  getValues: UseFormGetValues<EventFormData>;
  setValue: UseFormSetValue<EventFormData>;
  watch: UseFormWatch<EventFormData>;
};

export const EventFormStepContent = ({
  stepId,
  control,
  restaurantEvent,
  getValues,
  setValue,
  watch,
}: EventFormStepContentProps) => {
  if (stepId === 'event-information') {
    return <EventInformationStep control={control} setValue={setValue} />;
  }
  if (stepId === 'guest-capacity') {
    return (
      <GuestCapacityStep control={control} watch={watch} setValue={setValue} />
    );
  }
  if (stepId === 'event-photos') {
    return (
      <PhotosStep getValues={getValues} setValue={setValue} watch={watch} />
    );
  }
  if (stepId === 'event-add-ons') {
    return (
      <AddOnsStep
        key={restaurantEvent?.id ?? 'new'}
        control={control}
        restaurantEvent={restaurantEvent}
        setValue={setValue}
        watch={watch}
      />
    );
  }
  if (stepId === 'event-disclaimers') {
    return (
      <DisclaimersStep
        key={restaurantEvent?.id ?? 'new'}
        control={control}
        restaurantEvent={restaurantEvent}
        setValue={setValue}
        watch={watch}
      />
    );
  }
  if (stepId === 'event-confirmation') {
    return <EventConfirmationStep control={control} />;
  }
  return null;
};
